import React from 'react';

type CostumerFeedbackItemBlockProps = {
  feedback: string;
  writername: string;
};

const CostumerFeedbackItemBlock = ({data: {feedback, writername}}: {data: CostumerFeedbackItemBlockProps}) => {
  return (
    <div className='CostumerFeedbackItemBlock'>
      <div className='CostumerFeedbackItemBlock__feedback'>
      <span className='quote'>“</span>
        <p>{feedback}</p>
        <span className='quote'>“</span>
        </div>
    </div>
  );
};

export default CostumerFeedbackItemBlock;
